<template>
  <div class="cascading-element-hidden-prop"><slot></slot></div>
</template>

<script>

export default {
  name: "CascadingElementHiddenProp",
  components: {},
  props: { },

  data() {
    return {
      loading: false,
    }
  },
  methods: {},
}
</script>

<style lang="scss">
.cascading-element-hidden-prop {
  color: #afafaf;
  font-style: italic;
}
</style>